<style scoped>
    @import '../assets/css/supportSideBar.css';
</style>
<template>
    <div class="side-bar">
        <div>
            <a href="https://apps.appf.re/t4j/sup/sh" target="_blank" title="Submit a feature request or report a bug" @click="sendEvent(SubmitFeature)">
                <icon name="comments"></icon>
            </a>
            <a href="https://apps.appf.re/t4j/sup/mail" title="Contact us" @click="sendEvent(ContactUs)">
                <icon name="envelope"></icon>
            </a>
            <a href="https://apps.appf.re/t4j/doc" target="_blank" title="TFS4JIRA documentation" @click="sendEvent(ReadDocumentation)">
                <icon name="book"></icon>
            </a>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import { NAMESPACE as SUPPORT_ACTIVITY } from '../store/modules/supportActivity.js';
    import { NAMESPACE as APP_NAMESPACE } from '../store/modules/app.js';
    import 'vue-awesome/icons/book';
    import 'vue-awesome/icons/envelope';
    import 'vue-awesome/icons/comments';
    import Icon from 'vue-awesome/components/Icon.vue';
    export default {
        data() {
            return {
                SubmitFeature: {
                    SupportType: 'Submit feature request or report bug',
                    EventType: 'Clicked'
                },
                ContactUs: {
                    SupportType: 'Contact us (mailto)',
                    EventType: 'Clicked'
                },
                ReadDocumentation: {
                    SupportType: 'Link to TFS4JIRA documentation',
                    EventType: 'Clicked'
                }
            }
        },
        components: {
            'icon': Icon
        },
        methods: {
            ...mapActions({
                setUpService: SUPPORT_ACTIVITY.actions.SET_UP_SERVICE,
                sendEvent: SUPPORT_ACTIVITY.actions.SEND_EVENT
            }),
            ...mapGetters({
                contextPath: APP_NAMESPACE.getters.CONTEXT_PATH
            })
        },
        mounted: function() {
            this.setUpService({
                prefix: this.contextPath() + '/api/profiles'
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/SupportSideBar.vue